import { render, staticRenderFns } from "./ConsultasDT.vue?vue&type=template&id=c8ea6584&scoped=true&"
import script from "./ConsultasDT.vue?vue&type=script&lang=js&"
export * from "./ConsultasDT.vue?vue&type=script&lang=js&"
import style0 from "./ConsultasDT.vue?vue&type=style&index=0&id=c8ea6584&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ea6584",
  null
  
)

export default component.exports